import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const godsUnchainedQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-wishlist-added",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-wishlist",
  },
  {
    type: "link",
    key: "website",
    icon: "Play",
    label: "Watch Gods Unchained Trailer",
    caption: "Learn about what's coming up",
    linkUrl: "https://youtu.be/cDESNiMi-i4?si=U1a56m8WwgXitkza",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-trailer-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-trailer",
  },
  {
    type: "link",
    key: "website",
    icon: "Play",
    label: "Watch Fallen Age Expansion Trailer",
    caption: "See what's new in the expansion",
    linkUrl: "https://www.youtube.com/shorts/xwEfAhvC7Cc",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-trailer-2-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-trailer-trailer-2",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/godsunchained",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-discord-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-discord",
  },
];

const godsUnchainedQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Create a Gods Unchained account with Passport",
    caption: "Start your journey in Gods Unchained",
    linkUrl: "https://godsunchained.com/account/signin",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "e7e03f67-3643-4433-9ec4-31cf6bf895b0-website-create-account-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-website-create-account",
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: 'Visit Gods Unchained "Fallen Age" Expansion Page',
    caption: "Learn about the latest expansion",
    linkUrl: "https://godsunchained.com/expansions/fallen-age",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-website-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-website",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-onboarding-event",
    ruleId: "e7e03f67-3643-4433-9ec4-31cf6bf895b0-onboarding",
  },
];

export const godsUnchainedQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: godsUnchainedQuestsLvl1,
    // introModal: {
    //   title: "You're on your way to Level 1",
    //   description:
    //     "Thanks for following Gods Unchained. Keep showing your support and earn better perks while doing it.",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/GU_Levels_1.png?auto=format,compress",
    // },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: godsUnchainedQuestsLvl2,
    // introModal: {
    //   title: "Level 2, here you go",
    //   description:
    //     "People like you are making Gods Unchained a better and bigger game. Let's keep at it.",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/GU_Levels_2.png?auto=format,compress",
    // },
    // exitModal: {
    //   title: "That's all folks",
    //   description:
    //     "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/GU_Levels_3.png?auto=format,compress",
    // },
  },
];
